
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    Swiper,
    SwiperSlide,
  }
})
export default class extends Vue {
  @Prop() swiperData!: any;
  @Prop() title!: string;
  @Prop() partNum!: number;

  swiperOptions: any = {
    navigation: {
      nextEl: `#venueSwiper${this.partNum} .swiper-button-next`,
      prevEl: `#venueSwiper${this.partNum} .swiper-button-prev`,
    },
    // roundLengths : true,
    // autoplay: {
    //   delay: 10000,//10秒切换一次
    //   disableOnInteraction: false,
    //   pauseOnMouseEnter: true,
    // },
    loop: true,
    breakpoints: {
      1280: {
        loop: true,
        slidesPerView: 3,
        spaceBetween: 30,
      },
      768: {
        loop: true,
        slidesPerView: 2,
        spaceBetween: 30,
      },
      575: {
        loop: true,
        slidesPerView: 1,
      }
    },
    breakpointsBase: 'container',
  }

}
